import { CheckCircle, Cancel } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

interface IEmailConfirmationStatusProps {
  confirmed: boolean
}

export const EmailConfirmationStatus = (props: IEmailConfirmationStatusProps) => {
  const { confirmed } = props

  return (
    <Box paddingBottom={2} display='flex' alignItems='center' marginLeft={'auto'}>
      {confirmed ? (
        <>
          <CheckCircle color='success' style={{ marginRight: 8 }} />
          <Typography variant='body1' color='success.main'>
            Email Confirmed
          </Typography>
        </>
      ) : (
        <>
          <Cancel color='error' style={{ marginRight: 8 }} />
          <Typography variant='body1' color='error.main'>
            Email Not Confirmed
          </Typography>
        </>
      )}
    </Box>
  )
}
